import { Injectable } from '@angular/core';
import {
  IPerformanceResult,
  MARKER_NAME_PREFIX,
  MarkerNamesEnum,
} from './models';

@Injectable({
  providedIn: 'root',
})
export class I2gNgPerformanceService {
  private _window: any;

  constructor() {
    this._window = this.getNativeWindow();

    if (!this._window.performance) {
      throw new Error('Performance API is missing');
    }
  }

  /**
   * Create a mark for tracking time since timeOrigin
   * @param markerName Marker Name
   */
  mark(markerName: MarkerNamesEnum): boolean {
    if (!markerName || !this._window.performance.mark) {
      return false;
    }

    this._window.performance.mark(`${MARKER_NAME_PREFIX}:${markerName}`);
  }

  /**
   * Compute the results
   */
  getLastMeasurements(): IPerformanceResult {
    if (!this._window.performance.getEntriesByType) {
      return {};
    }

    const markers: PerformanceEntry[] = this._window.performance.getEntriesByType(
      'mark'
    );
    const results: IPerformanceResult = {};
    for (let i = 0; i < markers.length; i++) {
      if (markers[i].name.startsWith(MARKER_NAME_PREFIX)) {
        results[markers[i].name.split(':').pop()] = Number(
          (markers[i].startTime / 1000).toFixed(2)
        );
      }
    }

    return results;
  }

  /**
   * Clear all markers
   */
  clearAll(): void {
    if (this._window.performance.clearMarks) {
      this._window.performance.clearMarks();
    }
  }

  private getNativeWindow(): any {
    return window;
  }
}
